import { render, staticRenderFns } from "./selectCourseCard.vue?vue&type=template&id=906c75f8&scoped=true&"
import script from "./selectCourseCard.vue?vue&type=script&lang=js&"
export * from "./selectCourseCard.vue?vue&type=script&lang=js&"
import style0 from "./selectCourseCard.vue?vue&type=style&index=0&id=906c75f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906c75f8",
  null
  
)

export default component.exports